import React, { useEffect, useState } from 'react';
import { Button, Container, Form, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { FormField } from '../../../../service/types/types';
import { FormsService } from '../../../../service/forms.service';
import { FeedbackModal } from '../../../common/feedback.modal';
import FormFieldsEditor from './formFieldsEditor';

export default function FormEdit() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [formName, setFormName] = useState('');
  const [isSignRequired, setIsSignRequired] = useState(false);
  const [fields, setFields] = useState<FormField[]>([]);
  const [saving, setSaving] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<'success' | 'error'>('success');
  const [modalMessage, setModalMessage] = useState('');

  useEffect(() => {
    if (!id) return;
    FormsService.findById(id)
      .then((form) => {
        setFormName(form.name);
        setIsSignRequired(form.isSignRequired);
        setFields([...form.fields].sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0)));
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handleSave = async () => {
    if (!id) return;
    if (!formName.trim()) {
      alert('Ingrese un nombre para el formulario');
      return;
    }
    if (fields.length === 0) {
      alert('Ingrese al menos un campo');
      return;
    }
    setSaving(true);
    try {
      await FormsService.update(id, { name: formName, isSignRequired, fields });
      setModalType('success');
      setModalMessage('Formulario actualizado correctamente');
      setShowModal(true);
      setTimeout(() => navigate('/m4/form/list'), 2000);
    } catch {
      setModalType('error');
      setModalMessage('Error al actualizar el formulario');
      setShowModal(true);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Container fluid className="p-4 text-center">
        <Spinner animation="border" size="sm" /> Cargando formulario...
      </Container>
    );
  }

  return (
    <Container fluid className="p-4">
      <FeedbackModal
        show={showModal}
        onHide={() => setShowModal(false)}
        type={modalType}
        message={modalMessage}
        autoClose
        duration={3000}
      />
      <h3>Editar Lista de Control</h3>
      <Form>
        <Form.Group className="mb-3 w-100">
          <Form.Label>Nombre Lista de Control</Form.Label>
          <Form.Control
            type="text"
            value={formName}
            onChange={(e) => setFormName(e.target.value)}
            placeholder="Ej: Encuesta de satisfacción"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="isSignRequired">
          <Form.Check
            type="checkbox"
            label="¿Requiere firma?"
            checked={isSignRequired}
            onChange={() => setIsSignRequired(!isSignRequired)}
          />
        </Form.Group>

        <FormFieldsEditor fields={fields} onChange={setFields} />

        <br />
        <div className="d-flex gap-2">
          <Button variant="success" onClick={handleSave} disabled={saving}>
            {saving ? 'Guardando...' : 'Guardar cambios'}
          </Button>
          <Button variant="secondary" onClick={() => navigate('/m4/form/list')} disabled={saving}>
            Cancelar
          </Button>
        </div>
      </Form>
      <br />
    </Container>
  );
}
